// Mirrors the descriptive text shown as 3D <Text> in HolzarbeitTimeMachine.jsx,
// keyed by splinePoint (1-12), for display in the WaypointArrows sidebar.
const holzarbeitZeitmaschineTexte = {
  1: {
    de: "20.000 Jahre v. Chr. Eiszeit. Höhepunkt der Würm-Kaltzeit.",
    en: "20.000 years BC Ice Age. Peak of the Würm glacial period.",
  },
  2: {
    de: "12.000 Jahre v. Chr. Das Eis zieht sich zurück. Sümpfe und Moore kommen auf.",
    en: "12.000 years BC The ice retreats. Swamps and bogs appear.",
  },
  3: {
    de: "10.000 Jahre v. Chr.: Die letzten Gletscher der Würm Kaltzeit schmelzen. Birken- und Kieferwälder kommen auf.",
    en: "10.000 years BC: The last glaciers of the Würm glacial period melt. Birch and pine forests appear.",
  },
  4: {
    de: "5000 v. Chr.: Jungsteinzeit – Erste Hinweise auf eine mögliche Salzgewinnung in Hallstatt schon in der Jungsteinzeit sind fassbar.",
    en: "5.000 years BC: Neolithic period - first indications of possible salt production in Hallstatt.",
  },
  5: {
    de: "2000 Jahre v. Chr.: Frühbronzezeit. Der Bergbau wird intensiver. Und hier wird viel Holz benötigt.",
    en: "2000 years BC: Early Bronze Age. Mining becomes more intensive and a lot of wood is needed here.",
  },
  6: {
    de: "1400 Jahre v. Chr.: Mittelbronzezeit. Der Holzbedarf wird größer. Es kommt zu Kahlschlägen rund ums Bergwerk",
    en: "1400 years BC: Middle Bronze Age. The demand for wood increases. Clear-cutting occurs around the mine.",
  },
  7: {
    de: "1300 n. Chr. Mittelalter. Reorganisation des Salzbergbaus. Das Sudverfahren wird erfunden. Immer mehr Kahlschläge um die Bergwerke und um die Pfannhäuser.",
    en: "1300 AD: Middle Ages. Reorganisation of salt mining. The brewing process is invented. More and more clear-cutting around the mines and the salt works.",
  },
  8: {
    de: "1500 n. Chr. Das Salinenwesen expandiert. Immer mehr werden Lärchen-, Tannen- und Buchenwälder gerodet.",
    en: "1500 A.D. The salt works expands. More and more larch, fir and beech forests are cleared.",
  },
  9: {
    de: "1600 n. Chr. Höhepunkt der Rodungsflächen und des Kahlschlags. Nun kommt der Holzbedarf für die Salzschifffahrt dazu.",
    en: "1600 A.D. Peak of deforestation and clear-cutting. Now comes the need for wood for salt shipping.",
  },
  10: {
    de: "1700 n.Chr. Der Mischwald ist kahl geschlagen. Die Wiederaufforstung durch Fichten beginnt.",
    en: "1700 A.D. The mixed forest is stripped bare. Reforestation with spruce begins.",
  },
  11: {
    de: "1850 n.Chr. Der Holzbedarf für die Sudhäuser geht zurück. Der neue Energieträger für die Salzindustrie wird die Kohle.",
    en: "1850 A.D. The demand for wood for the salt works decreases. Coal becomes the new energy source for the salt industry.",
  },
  12: {
    de: "1900 n. Chr. Weitere Aufforstung durch Fichten. Denn im Bergbau ist der Holzbedarf nach wie vor groß.",
    en: "1900 A.D. Further afforestation with spruce trees. This is because there is a great need for wood in the mining industry.",
  },
};

export default holzarbeitZeitmaschineTexte;
